import React from "react";
import {
  Dialog,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box,
  IconButton,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import WorkOutlineIcon from "@mui/icons-material/WorkOutline";

function AssessmentModal({ open, onClose, onConfirm }) {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      BackdropProps={{
        sx: {
          backdropFilter: "blur(6px)",
          backgroundColor: "rgba(0,0,0,0.1)",
        },
      }}
      PaperProps={{
        sx: {
          border: "2px solid #ff6b6b",
          borderRadius: "16px",
          p: { xs: 1, sm: 2 }, // small padding on mobile
          background: "#fff8f8",
          position: "relative",
        },
      }}
    >
      {/* Close Icon */}
      <IconButton
        onClick={onClose}
        sx={{ position: "absolute", top: 10, right: 10 }}
      >
        <CloseIcon />
      </IconButton>

      <DialogContent sx={{ textAlign: "center" }}>
        {/* Circle Icon */}
        <Box
          sx={{
            width: { xs: 55, sm: 70 },
            height: { xs: 55, sm: 70 },
            mx: "auto",
            mb: 2,
            borderRadius: "50%",
            border: "2px solid #ff6b6b",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            color: "#ff6b6b",
          }}
        >
          <WorkOutlineIcon sx={{ fontSize: { xs: 28, sm: 36 } }} />
        </Box>

        {/* Title */}
        <Typography
          variant="h5"
          fontWeight="700"
          color="#e53935"
          gutterBottom
          sx={{ fontSize: { xs: "1.1rem", sm: "1.5rem" } }}
        >
          Risk Profile Update Notice!
        </Typography>

        {/* Description */}
        <Typography
          variant="body1"
          color="text.secondary"
          sx={{ fontSize: { xs: "0.85rem", sm: "1rem" } }}
        >
          Changing your Risk Profile will automatically update it across{" "}
          <strong>all your products.</strong>{" "}
          <em>This setting applies only for existing customers.</em>
        </Typography>

        {/* Subtitle */}
        <Typography
          sx={{
            mt: 3,
            fontWeight: 600,
            color: "#1a1a1a",
            fontSize: { xs: "1rem", sm: "1.25rem" },
          }}
        >
          Do you want to continue?
        </Typography>
      </DialogContent>

      {/* Actions */}
      <DialogActions
        sx={{
          pb: 3,
          flexDirection: { xs: "column", sm: "row" }, // buttons vertical on mobile
          gap: 2,
          justifyContent: "center",
        }}
      >
        <Button
          onClick={onClose}
          variant="outlined"
          sx={{
            width: { xs: "100%", sm: 160 },
            borderRadius: "8px",
            textTransform: "none",
            fontSize: { xs: "0.9rem", sm: "1rem" },
          }}
        >
          Cancel
        </Button>

        <Button
          onClick={onConfirm}
          variant="contained"
          sx={{
            width: { xs: "100%", sm: 220 },
            background: "#1a73e8",
            borderRadius: "8px",
            textTransform: "none",
            fontSize: { xs: "0.9rem", sm: "1rem" },
            "&:hover": { background: "#135fc3" },
          }}
        >
          Update My Risk Profile
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default AssessmentModal;
